module.exports = __webpack_public_path__ + "static/media/S35_B.3081fa67.png";